import { render, staticRenderFns } from "./RanchsyncButton.vue?vue&type=template&id=42f282b7&"
import script from "./RanchsyncButton.vue?vue&type=script&lang=js&"
export * from "./RanchsyncButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports